export function aiTemplateKey(templateId) {
  return `ai-${templateId}`;
}

export function buildAiTemplate(doc) {
  const textColor = doc.text || '#1a1a1a';
  const accent = doc.accent || textColor;
  const isDark = Boolean(doc.dark);
  const font = doc.font || 'Georgia,serif';

  const decoTop = doc.deco_top
    ? `<div class="qr-deco">${doc.deco_top}</div>`
    : '';
  const decoBottom = doc.deco_bottom
    ? `<div class="qr-deco">${doc.deco_bottom}</div>`
    : '';
  const titleBlock = doc.title
    ? `<div class="qr-title">${doc.title}</div>`
    : '<img src="/logo-taverne.png" class="qr-logo"/>';
  const subtitleBlock = doc.subtitle
    ? `<div class="qr-subtitle">${doc.subtitle.replace(/\n/g, '<br/>')}</div>`
    : '';

  return {
    label: doc.label,
    desc: doc.desc,
    qrColor: doc.qr || '#1a1a1a',
    isAi: true,
    aiData: doc,
    css: (size) => {
      const cellW = size === 'large' ? '95mm' : '63mm';
      const cellH = size === 'large' ? '133mm' : '88mm';
      const qrSize = size === 'large' ? '30mm' : '20mm';
      const logoH = size === 'large' ? '14mm' : '9mm';
      const tnumSize = size === 'large' ? '20pt' : '13pt';
      const txtSize = size === 'large' ? '8pt' : '6pt';
      const titleSize = size === 'large' ? '16pt' : '11pt';
      return `
      .qr-cell{width:${cellW};height:${cellH};border:1px dashed #bbb;display:flex;align-items:center;justify-content:center;page-break-inside:avoid;break-inside:avoid}
      .qr-inner{display:flex;flex-direction:column;align-items:center;text-align:center;padding:${size === 'large' ? '5mm' : '3mm'};width:100%;height:100%;background:${doc.bg};border:2px solid ${doc.border};color:${textColor};font-family:${font}}
      .qr-logo{height:${logoH};margin:${size === 'large' ? '3mm' : '2mm'} 0;${isDark ? 'filter:brightness(1.8);' : ''}}
      .qr-deco{font-size:${size === 'large' ? '10pt' : '7pt'};opacity:0.75;letter-spacing:3px}
      .qr-title{font-size:${titleSize};font-weight:bold;color:${accent};margin:1mm 0;letter-spacing:1px}
      .qr-subtitle{font-size:${txtSize};opacity:0.85;line-height:1.35;margin-bottom:1mm}
      .qr-wrap{background:white;border-radius:6px;padding:${size === 'large' ? '3mm' : '2mm'};margin:${size === 'large' ? '2mm' : '1mm'} 0}
      .qr-wrap svg{width:${qrSize}!important;height:${qrSize}!important}
      .qr-tnum{font-size:${tnumSize};font-weight:bold;color:${accent};margin:1mm 0}
      .qr-txt{font-size:${txtSize};opacity:0.85;line-height:1.3}
      .qr-txt b{display:block;color:${accent}}
      .qr-url{font-size:${size === 'large' ? '6pt' : '5pt'};opacity:0.5;margin-top:auto;padding-top:1mm}
      `;
    },
    html: (_t, num) => `
      <div class="qr-inner">
        ${decoTop}
        ${titleBlock}
        ${subtitleBlock}
        <div class="qr-wrap" id="svg-t${num}"></div>
        ${decoBottom}
        <div class="qr-tnum">Table ${num}</div>
        <div class="qr-txt"><b>Scannez pour commander</b>Ouvrez l'appareil photo</div>
        <div class="qr-url">latavernecay.fr</div>
      </div>
    `,
  };
}

export function resolveTemplate(templateKey, staticTemplates, aiTemplates) {
  if (templateKey.startsWith('ai-')) {
    const id = templateKey.replace(/^ai-/, '');
    const doc = aiTemplates.find(t => t.template_id === id);
    if (doc) return buildAiTemplate(doc);
  }
  return staticTemplates[templateKey] || staticTemplates.classique;
}
